module.exports = __webpack_public_path__ + "img/btn_menu_borad.245a058b.svg";